import { CircularProgress } from "@mui/material";

const LoadingIcon = () => {
    return (
        <div
            style={{
                display: "flex",
                justifyContent: "center",
                marginTop: "1em",
            }}
        >
            <CircularProgress />
        </div>
    );
};

export default LoadingIcon;
